import { render, staticRenderFns } from "./SellPlanEdit.vue?vue&type=template&id=06144d64&"
import script from "./SellPlanEdit.vue?vue&type=script&lang=js&"
export * from "./SellPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports